/*
 * Copyright © 2024 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

let uniqueId = 0;

export function nextId(prefix: string = ''): string {
    // prevent integer overflow: at least fail in a very loud way
    if (uniqueId === Number.MAX_SAFE_INTEGER) {
        throw new Error('Should not see me: MAX_SAFE_INTEGER reached');
    }

    return prefix + String(uniqueId++);
}
